import { TableCell, TableRow, Typography } from '@mui/material';
import * as React from 'react';
import { dayjs } from '../../../../../date-util';
import { LogEvent } from '../../api/scriptLogs';
import { SCRIPT_LOGS_ROW_DATE_FORMAT } from '../../data/constants';

const ScriptLogRow = (
	props: LogEvent & {
		selected: boolean;
		selectScriptLog(requestId: string): void;
	},
) => {
	const { selectScriptLog, requestId, message, timestamp } = props;
	return (
		<TableRow
			hover
			onClick={() => selectScriptLog(requestId)}
			sx={{
				cursor: 'pointer',
			}}
		>
			<TableCell sx={{ minWidth: 280 }}>
				<Typography fontWeight={500} variant='body2'>
					{dayjs(parseInt(timestamp)).format(SCRIPT_LOGS_ROW_DATE_FORMAT())}
				</Typography>
			</TableCell>
			<TableCell>{message}</TableCell>
		</TableRow>
	);
};

export default ScriptLogRow;
